const formatReadableFromSnakeCase = (string: string) => {
  return string
    .replace(/_/g, ' ')
    .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
};

export default formatReadableFromSnakeCase;
